import { fetchJSON } from '@catalogo/core-http';

export const fetchAddress = cep => {
  const url = `https://cep-v2-americanas-npf.b2w.io/cep/${cep}`;

  return fetchJSON(url).then(data => {
    const { address, city, state, neighborhood, number } = data;

    return {
      address,
      city,
      state,
      neighborhood,
      cep: number,
    };
  });
};
